import axios from '../utils/axiosConfig';
import { apiConfig } from '../config/api.config';

const getAuthToken = () => {
  return document.cookie.split(';').find(row => row.trim().startsWith('auth_token='))?.split('=')[1];
};

// 创建JSONP请求的辅助函数
const jsonp = (url, callbackParam = 'callback') => {
  return new Promise((resolve, reject) => {
    // 创建一个唯一的回调函数名
    const callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());
    
    // 创建script标签
    const script = document.createElement('script');
    
    // 设置全局回调函数
    window[callbackName] = (data) => {
      // 请求成功后，删除script标签和全局回调函数
      delete window[callbackName];
      document.body.removeChild(script);
      resolve(data);
    };
    
    // 处理错误
    script.onerror = () => {
      delete window[callbackName];
      document.body.removeChild(script);
      reject(new Error('JSONP request failed'));
    };
    
    // 添加callback参数到URL
    const separator = url.indexOf('?') !== -1 ? '&' : '?';
    script.src = `${url}${separator}${callbackParam}=${callbackName}`;
    
    // 添加script标签到DOM
    document.body.appendChild(script);
  });
};

export const mapService = {
  // 根据地理坐标获取附近阀门列表
  getValveListByGeo: async (lon, lat, distance, version, district, status, fmlsh) => {
    const response = await axios.get(`${apiConfig.getFullURL('/ark/valve/list/geo')}`, {
      params: {
        lon,
        lat,
        distance,
        version,
        district,
        status,
        fmlsh,
        auth_token: getAuthToken()
      }
    });
    return response.data;
  },

  // 搜索阀门
  searchValves: async (searchparams) => {
    try {
      // 构建腾讯地图suggestion API的URL
      const url = 'https://apis.map.qq.com/ws/place/v1/suggestion';
      const params = {
        region: '常州市',
        keyword: searchparams,
        key: '6C4BZ-LVJCQ-OZX55-BDMBZ-W5QMZ-E7BTZ',
        output: 'jsonp'  // 指定输出格式为jsonp
      };
      
      // 将参数添加到URL
      const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
      
      const fullUrl = `${url}?${queryString}`;
      
      // 使用JSONP发送请求，腾讯地图API使用'callback'作为回调参数名
      const data = await jsonp(fullUrl, 'callback');
      return data;
    } catch (error) {
      console.error('JSONP request failed:', error);
      throw error;
    }
  },
  
  // 根据地理坐标获取元素列表
  getElementListByGeo: async (lon, lat, distance, version, type) => {
    const response = await axios.get(`${apiConfig.getFullURL('/ark/element/list/geo')}`, {
      params: {
        lon,
        lat,
        distance,
        version,
        type,
        auth_token: getAuthToken()
      }
    });
    return response.data;
  }
};